export default {
  labels: {
    today: 'Oggi',
    pickup_time: 'Orario ritiro',
    delivery_time: 'Orario consegna',
  },
};
